import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import ViewListIcon from "@material-ui/icons/ViewList";
import { SMBoard as Board, Typography, Skeleton, Button, DialogOpportunity, makeStyles, Grid, DataTable } from "../../../..";
import { Link } from "react-router-dom";
var useStyles = makeStyles(function (theme) {
  return {
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    mr30: {
      margin: "30px"
    },
    layoutOptions: {
      display: "flex",
      "justify-content": "flex-end",
      width: "97%",
      padding: "10px 0px"
    }
  };
});

var FranchiseOpportunityList = function FranchiseOpportunityList(_ref) {
  var opportunities = _ref.opportunities,
      comercial = _ref.comercial,
      onCardClick = _ref.onCardClick,
      contacts = _ref.contacts,
      createOpportunity = _ref.createOpportunity,
      translation = _ref.translation,
      changeBoard = _ref.changeBoard,
      handleCardDragBoard = _ref.handleCardDragBoard,
      locale = _ref.locale,
      currency = _ref.currency;

  //   console.log("locale en FranchiseOpportunityList", locale);
  // const [ openTask, setOpenTask ] = useState(false);
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openOpportunity = _useState2[0],
      setOpenOpportunity = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showBoard = _useState4[0],
      setShowBoard = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDataTable = _useState6[0],
      setShowDataTable = _useState6[1];

  var classes = useStyles();

  var handleShowBoard = function handleShowBoard() {
    if (!showBoard) {
      setShowBoard(true);
      setShowDataTable(false);
    }
  };

  var handleShowDataTable = function handleShowDataTable() {
    if (!showDataTable) {
      setShowBoard(false);
      setShowDataTable(true);
    }
  };

  var handleDialogOpportunity = function handleDialogOpportunity() {
    // console.log("handledialog");
    setOpenOpportunity(!openOpportunity);
  };

  var properties = [{
    id: 0,
    visible: true
  }, {
    id: 1,
    visible: true
  }, {
    id: 2,
    visible: true
  }, {
    id: 3,
    visible: true
  }];
  return [/*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Pipeline"), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "contained",
    onClick: handleDialogOpportunity
  }, translation ? translation.buttons.add_opportunity : "+ Opportunity"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    component: Link,
    to: "/pipeline/past",
    className: classes.mr30,
    color: "primary",
    variant: "outlined"
  }, translation ? translation.buttons.view_past_opportunities : "Past Opportunities"))), /*#__PURE__*/React.createElement(Grid, {
    className: classes.layoutOptions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    "data-cy": "view-columns",
    onClick: handleShowBoard
  }, /*#__PURE__*/React.createElement(ViewColumnIcon, {
    fontSize: "default",
    color: showBoard ? "primary" : "inherit"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    "data-cy": "view-datatable",
    onClick: handleShowDataTable
  }, /*#__PURE__*/React.createElement(ViewListIcon, {
    fontSize: "default",
    color: showDataTable ? "primary" : "inherit"
  }))), comercial ? showBoard && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Board, {
    data: comercial,
    customCardLayout: true,
    onCardClick: onCardClick,
    cardDraggable: true,
    laneDraggable: false,
    properties: properties,
    changeBoard: changeBoard,
    translation: translation ? translation.views.board : null,
    handleCardDragBoard: handleCardDragBoard,
    locale: locale
  })) : [/*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Skeleton, null)))], opportunities && showDataTable && /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: "_opportunitiees",
    type: "opportunities",
    data: opportunities,
    translation: translation ? translation.views.datatable : null
  })))), /*#__PURE__*/React.createElement(DialogOpportunity, {
    open: openOpportunity,
    onClose: handleDialogOpportunity,
    variant: "add",
    createOpportunity: createOpportunity,
    contacts: contacts,
    currency: currency,
    translation: translation ? translation.dialogs.add_opportunity : null
  })];
};

export { FranchiseOpportunityList };